/**
 * Scheme-aware fills for chat surfaces. Mantine's numbered light shades
 * (`gray-0`, `blue-0`, `green-0`) are fixed values and stay pale in dark mode,
 * so every tinted surface pairs its light shade with a dark one here.
 * `light-dark()` follows `color-scheme`, which Mantine sets from the same
 * `data-mantine-color-scheme` attribute the console's theme toggle flips.
 */
export const SURFACE_COLORS = {
  /** Outline of the card itself. */
  cardBorder:
    'light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4))',
  /** An unselected option row or inset panel on the card. */
  inset: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))',
  /** A selected option row. */
  selected:
    'light-dark(var(--mantine-color-blue-0), var(--mantine-color-blue-light))',
  /** Settled notice once answers are submitted. */
  settledSubmitted:
    'light-dark(var(--mantine-color-green-0), var(--mantine-color-green-light))',
  /** Settled notice once the card is skipped. */
  settledSkipped:
    'light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6))',
} as const;
